<template>
  <input
    :type="type"
    :name="name"
    :class="['fm-def', w100 ? 'w-100' : '']"
    :value="value"
    :required="required"
    :placeholder="placeholder"
    :readonly="readonly"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    name: null,
    type: 'text',
    required: false,
    w100: false,
    value: '',
    placeholder: '',
    readonly: false,
  },
}
</script>

<style></style>
